// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "./GetCoupon/css/" + "site_app_entry" + "." + "b9d59a11" + ".css";
};